/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_P2Inputs */

const et_about_p2 = /** @type {(inputs: About_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me nägime, et enamik ettevõtteid kaotab raha, sest nende digitaalne fassaad on segane ja protsessid manuaalsed. Otsustasime seda muuta.`)
};

const en_about_p2 = /** @type {(inputs: About_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We saw that most companies lose money because their digital presence is confusing and their processes are manual. We decided to change that.`)
};

/**
* | output |
* | --- |
* | "We saw that most companies lose money because their digital presence is confusing and their processes are manual. We decided to change that." |
*
* @param {About_P2Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const about_p2 = /** @type {((inputs?: About_P2Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_P2Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_about_p2(inputs)
	return en_about_p2(inputs)
});